export default __webpack_public_path__ + "static/media/userOrder.29bbb938.svg";